import { useState } from "react";

export default function AddDepartmentModal({ onClose, onSave }) {
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const saveDepartment = async () => {
    const departmentName = name.trim();

    if (!departmentName) {
      setError("Department name is required.");
      return;
    }

    setSaving(true);
    setError("");

    try {
      const response = await fetch(
        "/api/inventory/departments",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({ name: departmentName }),
        },
      );

      const data = await response.json();

      if (data.status === "success") {
        onSave(data.data);
        onClose();
      } else {
        setError(data.message || "Could not create department.");
      }
    } catch (err) {
      console.error(err);
      setError("Could not connect to the backend.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal onClose={onClose}>
      <h2 className="mb-6 text-xl font-serif">Add Department</h2>

      <input
        autoFocus
        placeholder="Department Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") saveDepartment();
        }}
        className="w-full rounded-lg border border-white/10 bg-black/40 px-4 py-2"
      />

      {error && (
        <p className="mt-3 text-sm text-red-400">{error}</p>
      )}

      <div className="mt-8 flex justify-end gap-4">
        <button
          onClick={onClose}
          disabled={saving}
          className="rounded-xl border border-white/20 px-6 py-2"
        >
          Cancel
        </button>

        <button
          onClick={saveDepartment}
          disabled={saving}
          className="rounded-xl bg-amber-400 px-6 py-2 font-medium text-black"
        >
          {saving ? "Saving..." : "Save Department"}
        </button>
      </div>
    </Modal>
  );
}

function Modal({ children, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="relative w-full max-w-md rounded-2xl border border-white/10 bg-[#0b0b0f] p-8">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-400 hover:text-white"
        >
          ✕
        </button>

        {children}
      </div>
    </div>
  );
}